/**
 * The summary band's own box (`SummaryStrip`, and its loading shape in
 * `SummaryBandSkeleton`): a hairline above and below, the three groups side by side from `@2xl` of
 * the main column (672px) with a rule between each, stacked below it. A `.ts` module so the
 * skeleton, which a route's pending page imports, does not pull the loaded component in.
 */
export const BAND =
  'grid gap-4 border-y border-border-subtle py-4 @2xl:grid-cols-[auto_minmax(0,1fr)_auto]'
export const GROUP = 'min-w-0 @2xl:px-6 @2xl:first:pl-0 @2xl:last:pr-0'
export const RULED = 'border-border-subtle @2xl:border-l'
